import styled from 'styled-components';
import { Wrapper as WrapperList } from '../ListStyles';

export const Wrapper = styled(WrapperList)`
  text-align: center;

  fuel-sign {
    display: inline-block;
  }
`;
